import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client"
import React from "react"

/**
 * Fake Apollo client to prevent app from crashing when
 * corresponding GraphQL backend is inherently unavailable in
 * given environment (e.g. Meta AI service in sandbox environment).
 */
export const fakeApolloClient = new ApolloClient({
    link: createHttpLink({ uri: "" }),
    cache: new InMemoryCache()
})

export type NeqlClientMap = {
    turbine: ApolloClient<any>
    measurer: ApolloClient<any>
    metaAI: ApolloClient<any>
    metaAIApp(appID: string): ApolloClient<any>
}

export const NeqlClientContext = React.createContext<NeqlClientMap>({
    turbine: fakeApolloClient,
    measurer: fakeApolloClient,
    metaAI: fakeApolloClient,
    metaAIApp: () => fakeApolloClient
})
